import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AdminLoginPage from "./pages/AdminLoginPage";
import SpoletoDashboardPage from "./pages/SpoletoDashboardPage";
import HomePage from './pages/HomePage';
import ArticlesPage from './pages/ArticlesPage';
import ArticleDetailPage from './pages/ArticleDetailPage';
import AdminArticlesPage from './pages/AdminArticlesPage';
import NewsletterAdminPage from './pages/NewsletterAdminPage';
import MailingListsPage from './pages/MailingListsPage';
import EmailBroadcastPage from './pages/EmailBroadcastPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import AboutPage from './pages/AboutPage';
import GetStartedPage from './pages/GetStartedPage';
import ProtectedRoute from './components/ProtectedRoute';
import NewsPage from './pages/NewsPage';
import CategoriesPage from './pages/CategoriesPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/articles" element={<ArticlesPage />} />
          <Route path="/articles/:slug" element={<ArticleDetailPage />} />
          <Route path="/spoleto" element={<AdminLoginPage />} />
          <Route path="/spoleto/dashboard" element={<ProtectedRoute><SpoletoDashboardPage /></ProtectedRoute>} />
          <Route path="/spoleto/articles" element={<ProtectedRoute><AdminArticlesPage /></ProtectedRoute>} />
          <Route path="/spoleto/newsletter" element={<ProtectedRoute><NewsletterAdminPage /></ProtectedRoute>} />
          <Route path="/spoleto/mailing-lists" element={<ProtectedRoute><MailingListsPage /></ProtectedRoute>} />
          <Route path="/spoleto/broadcast" element={<ProtectedRoute><EmailBroadcastPage /></ProtectedRoute>} />
          <Route path="/spoleto/categories" element={<ProtectedRoute><CategoriesPage /></ProtectedRoute>} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/getstarted" element={<GetStartedPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
